<template>
  <div v-editable="blok" class="page">
    <StoryblokComponent
      v-for="nestedBlok in nestedBloks"
      :key="nestedBlok._uid"
      :blok="nestedBlok"
    />
  </div>
</template>

<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue';
import { computed } from 'vue';
import type { StoryblokPageBlok } from '@/features/storyblok/types';

const props = defineProps<{
  blok: StoryblokPageBlok;
}>();

const nestedBloks = computed(() => props.blok.content ?? props.blok.body ?? []);
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  gap: var(--ion-space-6);
}
</style>
